import React from "react";
import Indusone from "../../images/Projects Completed/projectsCompletedOne.jpeg";
// import Indusones from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/4. SSAW PIPES/4.jpg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-1 md:mb-4 text-center">
               AKT PROJECTS 
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify md:mt-2">
            AKT is proud to have successfully delivered a diverse portfolio of projects across various industries, showcasing our commitment to excellence, innovation, and client satisfaction. 
            From structural steelworks and industrial facilities to specialized trading and automotive applications, our completed projects stand as a testament to our technical expertise and reliability. 
            Each project reflects our attention to detail, quality craftsmanship, and ability to meet demanding timelines without compromising on standards. With a proven track record and a growing list of satisfied clients, 
            AKT continues to build trust through results-driven execution and enduring project value.
            </p>
          </div>
          {/* <div className="lg:col-span-5 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
          <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusones}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div> */}

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;

